import { type SvgIconComponent } from '@root/lib/types/components';

import { EnumHelper } from './helpers';

/**
 * Event type enumeration
 * @enum {number}
 * @export
 */
export enum EVENT_TYPE {
	TICKETS = 1,
	PACKAGES = 2,
	CHIPS = 3,
}

/**
 * Extra data interface for Event Type
 * @export
 */
export interface EventTypeExtraData {
	Icon?: SvgIconComponent;
}

/**
 * Event type data type
 * @export
 */
export interface EventTypeData extends EventTypeExtraData {
	eventTypeId: EVENT_TYPE;
}

/**
 * List of supported event types.
 * @see https://github.com/NFCtron/nfctron-db/blob/dev/diagrams/global.png
 * @type {EventTypeData[]}
 */
/**
 * Event type enumeration class.
 * @export
 */
class EventTypeEnum extends EnumHelper<EventTypeExtraData, EVENT_TYPE, 'eventType', 'eventTypeId'> {
	constructor() {
		super(
			'eventType',
			{
				[EVENT_TYPE.TICKETS]: {},
				[EVENT_TYPE.PACKAGES]: {},
				[EVENT_TYPE.CHIPS]: {},
			},
			'eventTypeId',
			null,
		);
	}
}

/**
 * Event type enumeration singleton instance export
 * @export
 */
export const eventTypeEnum = new EventTypeEnum();
